import React from 'react';
import { useHistory } from 'react-router-dom';
import { useGtXs } from '../../hooks/useGtXs';
import useSpaces from '../../hooks/useSpaces';
import Typography from '../Typography/Typography';
import styles from './MoreSpaces.module.scss';

interface MoreSpacesProps {
    id: number | number[]
    itemsPerRow?: 1 | 2 | 3 | 4 | 5
}

export default function MoreSpaces(props: MoreSpacesProps) {
    const { id, itemsPerRow = 4 } = props

    const { spaces } = useSpaces()
    const history = useHistory()
    const gtXs = useGtXs()

    const ids = Array.isArray(id) ? id : [id]
    const moreSpaces = spaces.filter(space => !ids.includes(space.id))

    const handleGoTo = (slug?: string) => {
        if (slug) {
            history.push(`${slug}`)
        }
    }

    const variant = gtXs ? "RocGroteskBold25" : "RocGroteskBold20"

    const gridStyle: React.CSSProperties = {
        display: 'grid',
        gridTemplateColumns: `repeat(${itemsPerRow}, 1fr)`,
        gap: '16px',
    }

    return (
        <div className={styles.Wrapper} style={gridStyle}>
            {moreSpaces?.map(space => {
                return (
                    <div key={space.id}>
                        <img src={space?.thumbnail} onClick={() => handleGoTo(space.slug)} alt={space.name} />
                        <Typography variant={variant}>
                            {space.name.toLocaleUpperCase()}
                        </Typography>
                    </div>
                )
            })}
        </div>
    )
}
